
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1800 166","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M231.303 3.678c6.871 6.38 9.317 16.795 7.336 31.246 5.938-12.96 13.447-20.312 22.526-22.056 14.717-2.826-5.558-.328-9.733 23.305 53.866 2.15 102.123 5.212 144.772 9.188 151.156 14.091 491.113 24.32 666.767 14.091 117.103-6.818 362.78-15.469 737.029-25.951v131.511H0V32.481c59.119-.292 114.139.083 165.06 1.127-2.271-27.64-25.895-30.61-10.304-27.62 10.5 2.015 18.905 11.508 25.211 28.48l-.2-.537c17.615.412 34.723.907 51.324 1.484 12.011-24.44-11.322-42.445.212-31.737z","fill":"#97D26F","fill-rule":"evenodd"}})])
          )
        }
      }
    